/* eslint-disable */
import React from 'react'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'

import PeriodOption from './PeriodOption'
import CalendarFilter from './CalendarFilter/CalendarFilter'

import { FilterTypeContainer, FilterTypes, Container, Content, ListItem, Title } from './styles'

const filterItems = [
  {
    value: 7,
    label: '7 dias',
  },
  {
    value: 15,
    label: '15 dias',
  },
  {
    value: 30,
    label: '30 dias',
  },
  {
    value: 60,
    label: '60 dias',
  },
  {
    value: 90,
    label: '90 dias',
  },
  {
    value: 0,
    label: 'Período específico',
  },
]

function FilterByPeriod({ selectedPeriod, onChange, options = filterItems, rangeForValidation = 90}) {
  return (
    <Container>
      <Content>
        <Title>Período</Title>
        <FilterTypeContainer>
          <FilterTypes>
            {options.map((type) => (
              <ListItem key={type.value}>
                <PeriodOption
                  key={type.value}
                  value={type.value}
                  onChange={onChange}
                  name="periodo"
                  label={type.label}
                  selectedPeriod={selectedPeriod}
                />
              </ListItem>
            ))}
          </FilterTypes>
        </FilterTypeContainer>
        {selectedPeriod === 0 && <CalendarFilter rangeForValidation={rangeForValidation}/>}
      </Content>
    </Container>
  )
}

const mapStateToProps = state => {
  const selector = formValueSelector('statementsFilter')
  return {
    selectedPeriod: selector(state, 'periodo')
  }
}

export default connect(mapStateToProps)(FilterByPeriod)



// WEBPACK FOOTER //
// ./src/app/modules/FilterByPeriod/FilterByPeriod.js